const shopList = () => import('@/views/main/shop/list/list.vue')
export default {
  path: '/main/shop/list',
  name: 'shopList',
  component: shopList,
  children: []
}
